module.exports = __webpack_public_path__ + "static/media/assitent-area-image.c6098f67.png";